import { ProductItem } from '@/lib/types/api';
import useTranslation from 'next-translate/useTranslation';
import { upperCaseIgnoreSpecialChars } from '@/lib/data-transformer/gindumacUtils';
import { startCase } from 'lodash-es';
import { ProductDataListItem } from './ProductDataListItem';
import { useRouter } from 'next/router';

export function ProductOverview({ product }: { product: ProductItem }) {
  const { t } = useTranslation('products');
  const { t: productst } = useTranslation('products');
  const { locale } = useRouter();
  const text = {
    overview: t('products:DETAIL_PAGE_OVERVIEW_TITLE'),
    // TODO: i18n fix bad key
    brand: t('seo:DETAIL_PAGE_OVERVIEW_BRAND'),
    model: t('products:DETAIL_PAGE_OVERVIEW_MODEL'),
    applicationType: t('products:DETAIL_PAGE_OVERVIEW_APPTYPE'),
    machineType: t('products:DETAIL_PAGE_OVERVIEW_MACHINETYPE'),
    year: t('products:DETAIL_PAGE_OVERVIEW_YEAR'),
    hours: t('products:DETAIL_PAGE_OVERVIEW_HOURS'),
    location: t('products:DETAIL_PAGE_OVERVIEW_LOCATION'),
    deliveryTime: t('products:DETAIL_PAGE_OVERVIEW_DELIVERY'),
    control_unit_brand: t('products:DETAIL_PAGE_OVERVIEW_CONTROL_UNIT_BRAND'),
    availability: t('products:DETAIL_PAGE_OVERVIEW_AVAILABILITY'),
  };

  return (
    <div id='data-overview' className='pl-4 lg:pl-8'>
      <p className='h2 py-6'>{text.overview}</p>
      <ul className='columns-1 md:columns-2'>
        <ProductDataListItem title={text.brand} subtitle={product.brand.name} />
        <ProductDataListItem
          title={text.year}
          subtitle={product.built_on + (locale == 'hr-HR' ? '.' : '')}
        />
        <ProductDataListItem
          title={upperCaseIgnoreSpecialChars(text.model)}
          subtitle={product.model}
        />
        <ProductDataListItem
          title={text.hours}
          subtitle={product.production_hours}
        />
        <ProductDataListItem
          title={text.applicationType}
          subtitle={
            product.application_types.length > 0
              ? productst(`${product.application_types[0].name}`)
              : ''
          }
        />
        <ProductDataListItem
          title={text.location}
          subtitle={productst(`${product.country}`)}
        />
        <ProductDataListItem
          title={text.machineType}
          subtitle={
            product.machine_types.length > 0
              ? productst(`${product.machine_types[0].name}`)
              : ''
          }
        />
        <ProductDataListItem
          title={text.availability}
          subtitle={t(startCase(product.availability))}
        />
        <ProductDataListItem
          title={text.control_unit_brand}
          subtitle={product.control_unit_brand}
        />
      </ul>
    </div>
  );
}
